/*
 * Hide/Show inputs according to sibling values
*/

import EventBus from '../event-bus.js'
import jQuery from 'jquery'

class DynamicInputs {
    
    /**
     * Construct module
     * @param fieldGroups
    */
    constructor(fieldGroups) {
        
        //Initial handling of fieldGroups on page load
        fieldGroups.each((i, element) => {
            
            let
                fieldGroup = jQuery(element),
                target = this.getTargetElement(fieldGroup)
                
            //Special event for Radio siblings
            if (target.attr('type') == 'radio') {
                target.closest('form').find('input[type="radio"][name="' + target.attr('name') + '"]').change(() => {
                    this.handleUpdate(fieldGroup)
                })
            }
            else {
                //Bind invocation event to target element
                target.change(() => {
                    this.handleUpdate(fieldGroup)
                })
            }
            
            //Bind invocation event to target element
            target.on('refresh-dynamic-input',() => {
                this.handleUpdate(fieldGroup)
            })
            
            //Invoke update event on fieldGroup
            this.handleUpdate(fieldGroup)
            
        })
    
    }
    
    /**
     * Get element input display is invoked by
     * @param fieldGroup
    */
    getTargetElement(fieldGroup) {
        
        let
            target = fieldGroup.data('show-element'),
            element = jQuery(target)
        
        return element
        
    }
    
    /**
     * A field has been updated or the page has loaded
     * @param fieldGroup
    */
    handleUpdate(fieldGroup) {
        
        let
            element = this.getTargetElement(fieldGroup),
            showValues = String(fieldGroup.data('show-value')).split(',')
        
        //Cancel if target element could not be queried
        if (element.length === 0) {
            return
        }

        let
            inverted = fieldGroup.data('inverted'),
            showIfAnyValue = showValues.length == 1 && showValues[0] == '*',
            elementType = element.attr('type'),
            isCheckbox = elementType == 'checkbox',
            isRadio = elementType == 'radio',
            value = element.val(),
            showInput = (isCheckbox || isRadio) ? (element.is(':checked') == (showValues[0] == 1 ? true : false)) : ((showIfAnyValue && value) || jQuery.inArray(value, showValues) > -1 ? !inverted : inverted),
            fieldInputs = fieldGroup.show().find('input, select, textarea')
        
        if (showInput) {
            
            fieldGroup.show()
            fieldInputs.prop('disabled', false)
            
            if (fieldInputs.length > 1) {
                return
            }
            
            //Handle dynamic select options
            
            let optionsMap = fieldInputs.data('options-map')
            
            if (optionsMap) {
                
                let
                    option,
                    optionVal
                
                //Reset select value if it is not supported within the mapping
                let fieldVal = fieldInputs.val()
                if (!optionsMap.hasOwnProperty(fieldVal) || optionsMap[fieldVal] != value) {
                    fieldInputs.val('')
                }
                
                //Enable/Disable options according to value mapping
                fieldInputs.find('option').each((i, element) => {
                    option = jQuery(element)
                    optionVal = option.val()
                    (optionsMap.hasOwnProperty(optionVal) && optionsMap[optionVal] == value) ? option.show().prop('disabled', false) : option.hide().prop('disabled', true)
                })
                
            }
            
            return
            
        }

        fieldGroup.hide()
        fieldInputs.prop('disabled', true)

    }
    
}

EventBus.subscribe('init-modules',() => {
    
    let fieldGroups = jQuery('.field-dynamic')
    
    if (fieldGroups.length > 0) {
        new DynamicInputs(fieldGroups)
    }
    
})

export default DynamicInputs